import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-gamepad-line text-xl text-primary-400"></i>
                </span>
                <span className="font-heading text-lg font-bold text-background-50">Galgame资源大全</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                最全面的中文galgame资源聚合平台，提供galgame资源下载导航、汉化补丁、推荐合集与新手入门指南。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">
                分类导航
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/story"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    分类浏览
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">
                关注我们
              </h4>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                获取最新的galgame资源资讯和汉化动态
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all duration-200"
                  rel="nofollow"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all duration-200"
                  rel="nofollow"
                  aria-label="B站"
                >
                  <i className="ri-bilibili-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all duration-200"
                  rel="nofollow"
                  aria-label="QQ"
                >
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} Galgame资源大全 · 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}